module.exports = "./assets/assets/1.主持开标.b04eced7.docx";